export const site = {
  name: "看料爆料",
  tagline: "匿名线索投稿平台",
  slogan: "让每一条真料，都安全见光",
  intro:
    "看料爆料是一个面向中文读者的爆料线索聚合与投稿平台。我们接收内幕、证据与私下拿到的素材，快速筛选核实，把经得起推敲的猛料放给大家，同时尽最大努力降低投稿人的曝光风险。",
  email: "tips@kanliaobaoliao.com",
  since: "2021",
  handlingHours: "12 小时内完成初筛",
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "爆料库", path: "/scoops" },
  { label: "热门专题", path: "/topics" },
  { label: "常见问题", path: "/faq" },
  { label: "关于我们", path: "/about" },
];

export const footerGroups = [
  {
    title: "浏览内容",
    links: [
      { label: "最新爆料", path: "/scoops" },
      { label: "消费维权", path: "/scoops?cat=consumer" },
      { label: "行业内幕", path: "/scoops?cat=industry" },
      { label: "热门专题", path: "/topics" },
    ],
  },
  {
    title: "参与投稿",
    links: [
      { label: "投稿通道", path: "/submit" },
      { label: "投稿规范", path: "/faq" },
      { label: "隐私与安全", path: "/faq" },
      { label: "核实与发布", path: "/faq" },
    ],
  },
  {
    title: "了解平台",
    links: [
      { label: "关于我们", path: "/about" },
      { label: "内容原则", path: "/about" },
      { label: "用户口碑", path: "/about" },
      { label: "常见问题", path: "/faq" },
    ],
  },
];